import styled from 'styled-components'
import { grayLighter } from 'utils/style-utils'

export const StyledSubHeader = styled.span`
  font-size: 0.875rem;
  color: ${grayLighter};
`
